export const RESPONSE_STATUS = {
  requestPending: "pending",
  requestFullfilled: "fullfilled",
  requestRejected: "rejected",
};

export const CONSTANTS = {
  countCacheName: "casa-web-counts",
  lastForceRefreshedTime: "lastForceRefreshedTime",
};

export const ENITTY = {
  "TASKS": "tasks",
  "LEADS": "leads",
  "OPPORTUNITY": "opportunity",
  "SMARTVIEWS": "smartviews",
  "ACTIVITES": "activities",
}

export const widgetTypes = {
  SingleCounter: "singlecounter",
  SpeedoMeter: "speedometer",
  ProgressBar: "progressbar",
  Banner: "banner",
  Calendar: "calendarview",
  IconLauncher: "iconlauncher",
};
export const formEntites = {
  "Lead/Form": {
    name: "Lead/Form",
    formEntity: 0,
    PermissionEntityType: "LEAD",
  },
  "Opportunity/Form": {
    name: "Opportunity/Form",
    formEntity: 1,
    PermissionEntityType: "OPPORTUNITY",
  },
  "Activity/Form": {
    name: "Activity/Form",
    formEntity: 2,
    PermissionEntityType: "ACTIVITY",
  },
  "Task/Form": {
    name: "Task/Form",
    formEntity: 3,
    PermissionEntityType: "TASK",
  },
  "Account/Form": {
    name: "Account/Form",
    formEntity: 5,
    PermissionEntityType: "ACCOUNTS",
  },
};
export const TEXT_CONSTANTS = {
  somethingWentWrong: "Something Went Wrong",
  noTasksScheduled: "No Tasks Scheduled",
  noAppointmentsScheduled:"No Appointments Scheduled",
  retry:'Retry',
};
